module.exports = (s) => {
  return [
    {
      name: '应用名称',
      value: 'app_name',
    },
    {
      name: '应用AppID',
      value: 'app_id',
    },
    {
      name: '应用secret',
      value: 'secret',
    },
    {
      name: '创建时间',
      value: 'created_at',
    },
    {
      name: '返点',
      value: 'rebate',
    },
    {
      name: '操作',
      value: '',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div', null, [
          h('el-button',
            {
              props: {
                size: 'mini',
              },
              on: {
                click: () => {
                  s.onAuth(row.app_id);
                },
              },
            },
            '授权'
          ),
          h('el-button',
            {
              props: {
                type: 'primary',
                size: 'mini',
              },
              on: {
                click: () => {
                  s.openDialog(2, row);
                },
              },
            },
            '编辑'
          ),
          h('el-button',
            {
              props: {
                type: 'danger',
                size: 'mini',
              },
              on: {
                click: () => {
                  s.delConfig(row.id);
                },
              },
            },
            '删除'
          ),
        ]);

        return ele;
      },
    },
  ];
};
